import api from '../library/axios';

export default {
  getWorkspaces() {
    return api({
      method: 'get',
      url: '/api/backoffice/migration/workspaces',
    });
  },
  getChannel(workspace_id) {
    return api({
      method: 'get',
      url: `/api/backoffice/migration/channel/${workspace_id}`,
    });
  },
  getDetailWaba(workspace_id, waba_id) {
    return api({
      method: 'get',
      url: `/api/backoffice/migration/detail/${workspace_id}/${waba_id}`,
    });
  },
  getOTP(form) {
    return api({
      method: 'post',
      url: '/api/backoffice/migration/otp',
      data: form,
    });
  },
  submitOTP(form) {
    return api({
      method: 'post',
      url: '/api/backoffice/migration/submit',
      data: form,
    });
  },
};
